import clsx from 'clsx'
import React, { FC } from 'react'

import { useSplitTest } from '@Globals/SplitTests/Hooks'

import styles from './RoundCheckbox.module.scss'

export interface RoundCheckboxProps {
  ariaHidden?: boolean
  ariaLabel?: string
  ariaLabelledby?: string
  checked: boolean
  children?: React.ReactNode
  childrenWrapperClassName?: string
  className?: string
  id?: string
  onCheck?: (checked: boolean) => void
  tabIndex?: number
}

export const RoundCheckbox: FC<RoundCheckboxProps> = ({ ariaHidden,
  ariaLabel, ariaLabelledby,
  checked, children, childrenWrapperClassName, className, id, onCheck, tabIndex }) => {
  const cofDesignV1 = useSplitTest('cof_design_v1', 'b')

  const updateChecked = () => {
    if (onCheck) {
      onCheck(!checked)
    }
  }
  return (
    <div
      className={clsx(
        className,
        styles.roundCheckbox,
        cofDesignV1 && styles.cofDesignV1,
      )}
      onClick={updateChecked}
    >
      <span className={styles.label}>
        <input
          aria-hidden={ariaHidden}
          aria-label={ariaLabel}
          aria-labelledby={ariaLabelledby}
          checked={checked}
          id={id}
          onChange={updateChecked}
          tabIndex={tabIndex}
          type="checkbox"
        />
        <span
          aria-hidden="true"
          className={clsx(styles.roundCheckbox, !!checked && styles.roundCheckboxActive, 'check')}
        >
          <span className={clsx('roundCheckboxCircle', styles.roundCheckboxCircle)} />
        </span>
        <span className={clsx(styles.roundCheckboxLabel, childrenWrapperClassName)}>{children}</span>
      </span>
    </div>
  )
}
